import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table'
import Cookies from 'universal-cookie';
import Dialog from "./Dialog";
import { useSearchParams } from 'react-router-dom';
  import {db} from "../../firebase-config";
  import {storage} from "../../firebase-config";
  import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
  import { collection,getDoc, getDocs, addDoc, updateDoc, deleteDoc, doc, Firestore, query, where,orderBy } from "firebase/firestore";
import { Card } from 'react-bootstrap';
import {getAge} from "../../Helper";
import Moment, { relativeTimeRounding } from 'moment';
import Modal from 'react-modal';
import Alert from 'react-bootstrap/Alert';
import Cleave from 'cleave.js/react';
import Wait from '../../resources/wait.gif';
import { modalStyle } from '../utils/shared';
const axios = require('axios').default;
const header = {"Access-Control-Allow-Origin": "*",'content-type': 'application/x-www-form-urlencoded'}


const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    width: '900px',
    height: '460px',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    // zIndex: 100,
  },
  overlay: {zIndex: 100}
};

const imageUrls = [
  "https://logos-world.net/wp-content/uploads/2020/04/Visa-Logo.png",
  "https://brand.mastercard.com/content/dam/mccom/brandcenter/thumbnails/mastercard_vrt_rev_92px_2x.png",
  "https://www.discover.com/company/images/newsroom/media-downloads/discover.png",
  "https://s1.q4cdn.com/692158879/files/design/svg/american-express-logo.svg",
  "https://cdn4.iconfinder.com/data/icons/simple-peyment-methods/512/diners_club-512.png",
  "https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/JCB_logo.svg/1280px-JCB_logo.svg.png"
]

const PlayerList = (props) => {
    const cookies = new Cookies();
    const [player,setPlayer] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [age,setAge] = useState("");
    const [uid,setUid] = useState("");
    const [programId,setProgramId] = useState("");
    const [programName,setProgramName] = useState("");
    const [programs,setPrograms] = useState([]);
    const [playerfiles,setPlayerfiles] = useState([]);
    const [assignedPrograms,setAssignedPrograms] = useState([]);
    const [isLoadingModal, setLoadingModal] = useState(false);
    const [disabledEnvelop, setDisabledEnvelop] = useState(false);   
    const programsCollectionRef = collection(db,"programs");
    const assignedProgramsRef = collection(db,"assignedprograms");
    const playerfilesCollectionRef = collection(db,"players", cookies.get("player")??'none', "playerfiles");
    let [searchParams, setSearchParams] = useSearchParams();
    const [errorPayment, setErrorPayment] = useState(false); 
    const [successPayment, setSuccessPayment] = useState(false); 
    const [validToken,setValidToken] = useState("");
    const [end_date,setEndDate] = useState("");

    //MANUAL PAYMENT.
    const [releasePaymentNote,setReleasePaymentNote] = useState("");

    //PAYMENT ERROR
    const [paymentError,setPaymentError] = useState(false);
    const [paymentErrorMessage,setPaymentErrorMessage] = useState("");

      //ERROR
  const [error,SetError] = useState(false);
  const [errorMessage,SetErrorMessage] = useState("");

    //CCARD 
    const [creditCardNum, setCreditCardNum] = useState('#### #### #### ####');
    // const [cardType, setCardType] = useState('')
    const [cardHolder, setCardHolder] = useState('Your Full Name');
    const [expireMonth, setExpireMonth] = useState('01');
    const [expireYear, setExpireYear] = useState('2022');
    const [cvv, setCvv] = useState('');
    const [cardTypeUrl, setCardTypeUrl] = useState('https://logos-world.net/wp-content/uploads/2020/04/Visa-Logo.png');
    const [isStripe_pm, setIsStripe_pm] = useState(false);
    const [stripe_pm, setStripe_pm] = useState("");
    const [stripe_name, setStripe_name] = useState("");
    const [stripe_last4, setStripe_last4] = useState("");
    const [stripe_network, setStripe_network] = useState("");
    const [pintent_id, setPintent_id] = useState("");
    const handleNum = (e) => {
      setCreditCardNum(e.target.rawValue);
      // console.log(e.target.value);
    }
  
    const handleType = (type) => {
      // setCardType(type);
      // console.log(type);
  
      if(type === "visa") {
        setCardTypeUrl(imageUrls[0]);
        console.log("Visa")
      } else if(type === "mastercard") {
        setCardTypeUrl(imageUrls[1]);
        console.log("Mastercard")
      } else if(type === "discover") {
        setCardTypeUrl(imageUrls[2]);
        console.log("Discover")
      } else if(type === "amex") {
        setCardTypeUrl(imageUrls[3]);
        console.log("Amex")
      } else if(type === "diners") {
        console.log("Diners")
        setCardTypeUrl(imageUrls[4])
      } else if(type === "jcb") {
        console.log("JCB");
        setCardTypeUrl(imageUrls[5]);
      }
    }
    
    const handleCardHolder = (e) => {
      setCardHolder(e.target.value);
    }
  
    const handleExpMonth = (e) => {
      setExpireMonth(e.target.value);
    }

    const handlecvc = (e) => {
      setCvv(e.target.value);
    }
  
    const handleExpYear = (e) => {
      setExpireYear(e.target.value);
    }

    //END STRIPE
    useEffect(()=>{
      if(isLoading){
          document.getElementById("data").style.display = "none";
          document.getElementById("loader").style.display = "block";
      }else{
          document.getElementById("data").style.display = "block";
          document.getElementById("loader").style.display = "none";
      }
  },[isLoading]);

    useEffect(() => {
      // alert(cookies.get('player'));
      if(cookies.get('player')){
        getPlayers();
      }else{
        setLoading(false);
      }

      if(props.userHome.userData.stripe_pm!=""){
        setIsStripe_pm(true);
        getCard();
      }else{
        setIsStripe_pm(false);
      }
      getvalidToken();

    }, []);

    const sendEnvelope = async (id) => {
      setLoading(true);
      setDisabledEnvelop(true);
      var body = {
        "email": props.userHome.userData.email,
        "name": props.userHome.userData.name + " " + props.userHome.userData.lastname,
        "uid": props.userHome.userData.id,
        "id":id,
        "playerid":cookies.get('player'),
        "clubid":props.userHome.userData.club_id
      };
      
      axios.post(process.env.REACT_APP_BACKEND+'sendEnvelope', {
        body,header
      })
      .then(function (response) {
        console.log(response.data);
        window.open(response.data.redirectUrl, "_blank");
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
    }

    const getEnvelope = async (envelopeId,id) => {
      setLoading(true);
      setDisabledEnvelop(true);
      var body = {
        "email": props.userHome.userData.email,
        "name": props.userHome.userData.name + " " + props.userHome.userData.lastname,
        "uid": props.userHome.userData.id,
        "id":id,
        "envelopeId": envelopeId,
        "playerid":cookies.get('player'),
        "clubid":props.userHome.userData.club_id
      };
      
      axios.post(process.env.REACT_APP_BACKEND+'getEnvelope', {
        body,header
      })
      .then(function (response) {
        console.log(response.data);
        window.open(response.data.redirectUrl, "_blank");
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
    }

    const getvalidToken = async () => {
      const docRef = doc(db, "settings", "QmalH63MSFFB1ZbLoHCB");
      await getDoc(docRef).then((docSnap)=>{
        if (docSnap.exists()){
          setValidToken(docSnap.data().validToken);
          var date = new Date();
          
          if(docSnap.data().validToken?.toDate()<date){
            // alert(docSnap.data().validToken?.toDate());
            var body = {};
            axios.post(process.env.REACT_APP_BACKEND+'getDocusignToken', {
              body,header
            })
            .then(function (response) {
              console.log(response);
            })
            .catch(function (error) {
              console.log(error);
            });
          }
        }else {
          console.log("No such document");
        }
      });
    }

    const getPlayers = async () => {
      const docRef = doc(db, "players", cookies.get('player'));
      const docSnap = await getDoc(docRef).then((docSnap)=>{
        if (docSnap.exists()) {
          console.log(docSnap.data());
          setPlayer(docSnap.data());
          setAge(getAge(Moment(docSnap.data().birthdate?.toDate()).format('MM/DD/YYYY')));
          getPrograms();
          getFiles();
          getProgramsPlayer(docSnap.data());
        }else {
          console.log("No such document");
        }
      });
    }

    const getFiles = async () => {
        const q = query(playerfilesCollectionRef);
        const data = await getDocs(q);
        setPlayerfiles(data.docs.map((doc)=> ({...doc.data(), id: doc.id})));
        
    }

    const getPrograms = async () => {
      const q = query(programsCollectionRef,where("club_id", "==",props.userHome.userData.club_id),where("status", "==","Active"));
      const data = await getDocs(q);
      setPrograms(data.docs.map((doc)=> ({...doc.data(), id: doc.id})))
    }

    const getProgramsPlayer = async () => {
      const q = query(assignedProgramsRef,where("player_id", "==",cookies.get('player')),orderBy("date", "desc"));
      const data = await getDocs(q);
      setAssignedPrograms(data.docs.map((doc)=> ({...doc.data(), id: doc.id})));
      setLoading(false);
    }

    //CONFIRM
    const [dialog, setDialog] = useState({
      message: "",
      isLoading: false,
      action:"",
      //Update
      nameProduct: "",
      uid: "",
      pintent_id:""
    });

    const handleDialog = (message, isLoading, nameProduct, action, uid,pintent_id) => {
     
      setDialog({
        message,
        isLoading,
        action,
        //Update
        nameProduct,
        uid,
        pintent_id
      });
    };

    const handleDelete = (action,uid,name,pintent_id) => {   
      //Update
      handleDialog("Are you sure you want to delete permanently, you cannot undo?", true,name,action, uid, pintent_id);
      
    };

    const areUSureDelete = (choose) => {
      if (choose) {
        if (dialog.action == "player") {
          deletePlayer();
        }
        if (dialog.action == "program") {
          deleteProgramSt(dialog.uid,dialog.pintent_id);
        }
        if (dialog.action == "profile_picture") {
          deleteFile();
        }
        if (dialog.action == "playerfile") {
          deletePlayerFile(dialog.uid);
        }
        handleDialog("", false,"","","");
      } else {
          handleDialog("", false,"","","");
      }
    };
    
    const deletePlayer = async () => {
      setLoading(true);

      const userDoc = doc(db, "players", cookies.get('player'));
      await deleteDoc(userDoc).then(()=>{
        {assignedPrograms.map((assignedProgram) => {
          deleteProgram(assignedProgram.id)
        })}
        alert("deleted correctly");
        setLoading(false);
        cookies.remove('player', { path: '/' });
        props.updateStatePlayer(0,"")
    });
    }

    const deleteProgramSt = async (uid,pintent_id) => {
      setLoadingModal(true);
      var body = {
        "pintent_id": pintent_id,
      };
      axios.post(process.env.REACT_APP_BACKEND+'cancelPIntents', {
        body,header
      })
      .then(function (response) {
        deleteProgram(uid);
      })
      .catch(function (error) {
        console.log(error);
      });
    }

  
    const deleteProgram = async (uid) => {
      setLoading(true);
      const userDoc = doc(db, "assignedprograms", uid);
      await deleteDoc(userDoc).then(()=>{
        alert("deleted correctly");
        getProgramsPlayer();
        setLoading(false);
      });
    }

    const releasePaymentSt = async () => {
      if(releasePaymentNote.length<=4){
        alert("Please write a NOTE to release this payment.");
        return;
      }
      setLoadingModal(true);
      var body = {
        "pintent_id": pintent_id,
      };
      axios.post(process.env.REACT_APP_BACKEND+'cancelPIntents', {
        body,header
      })
      .then(function (response) {
        releasePayment(uid);
      })
      .catch(function (error) {
        console.log(error);
      });
    }

    const releasePayment = async (uid) => {
      setLoading(true);
      const userDoc = doc(db, "assignedprograms", uid);
      var date = new Date();
      const newFields = { 
        program_paid: "yes",
        status: "Paid",
        date_paid: date,
        manual_paid: "yes",
        manual_paid_note: releasePaymentNote,
        manual_paid_by: props.userHome.userData.name };
      await updateDoc(userDoc, newFields).then(async(res)=>{
        const userDoc2 = doc(db, "players", cookies.get("player"));
        const newFields = {
          active_program: "1",
          program_name:programName,
          program_id:programId,
        };  
        await updateDoc(userDoc2, newFields).then(async(res)=>{
          alert("Released correctly");
          getProgramsPlayer();
          setLoadingModal(false);
          setIsOpen2(false);
          setLoading(false);
        });
      });
    }

    //Adding program to Player
    var rowCounter = 0;
    var rowCounter2 = 0;
    var rowCounter3 = 0;
    let subtitle;
    const [modalIsOpen, setIsOpen] = React.useState(false);
    const [modalIsOpen2, setIsOpen2] = React.useState(false);
    const [modalIsOpen3, setIsOpen3] = React.useState(false);
    const [modalIsOpen4, setIsOpen4] = React.useState(false);
    const [image, setImage] = useState(null);
    const [url, setUrl] = useState("");
    const [progress, setProgress] = useState(0);

    const handleChange = e => {
      if (e.target.files[0]) {
        setImage(e.target.files[0]);
      }
    };

    function closeModal() {
      setIsOpen(false);
    }
    function closeModal2() {
      setIsOpen2(false);
    }
    function closeModal3() {
      setIsOpen3(false);
    }
    function closeModal4() {
      setIsOpen4(false);
    }

    function openModal() {
      setLoadingModal(false);
      setIsOpen(true);
    }
    function openModal3() {
      setLoadingModal(false);
      setIsOpen3(true);
    }
    function openModal4() {
      setLoadingModal(false);
      setIsOpen4(true);
    }

    function openModal2(uid,program_name,pintent_id,end_date,program_id) {
      setLoading(true);
      if(props.userHome.userData.stripe_pm!=""){
        getCard();
      }else{
        setLoading(false);
      }
      setUid(uid);
      setProgramName(program_name);
      setPintent_id(pintent_id);
      setEndDate(end_date);
      setProgramId(program_id);
      setIsOpen2(true);
    }

    const addProgramSt = async () => {
      setLoadingModal(true);
      var data = document.getElementById("program").value;
      data = data.split("****");
      var end_date = "2022-01-01";
      var body = {
        "uid":data[0],
        "amount": data[2],
        "receipt_email": props.userHome.userData.email,
        'name': programName,
        'player': player.name,
        'customer_id': props.userHome.userData.stripe_id,
        'end_date':end_date
      };
      axios.post(process.env.REACT_APP_BACKEND+'createPIntents', {
        body,header
      })
      .then(function (response) {
        if(response.data.result==="0"){
          SetError(true);
          SetErrorMessage(response.data.message);
          setLoadingModal(false);
          return;
        }
        addProgram(response.data.pintent_id);
      })
      .catch(function (error) {
        console.log(error);
      });
    }

    const addFile = async (url) => {
      var date = new Date();
      await addDoc(playerfilesCollectionRef,{
        url:url,
        date:date,
        fileref: "playerfiles/"+cookies.get("player")+"/"+image.name,
        by: props.userHome.userData.name + " " + props.userHome.userData.lastname
      }).then((res) => {
        setLoadingModal(false);
        setIsOpen4(false);
        getFiles();
      });
    }

    const addProgram = async (pintent_id) => {
      var data = document.getElementById("program").value;
      data = data.split("****");
      setLoadingModal(true);
      var date = new Date();
      await addDoc(assignedProgramsRef,{
        club_id:props.userHome.userData.club_id,
        player_id:cookies.get('player'),
        player_name:player.name,
        player_birthdate:player.birthdate,
        program_id:data[0],
        program_name:data[1],
        date:date,
        program_paid:"no",
        date_paid:"",
        stripe_pm: "",
        price:data[2],
        status: "Not Paid",
        minAge: data[3],
        maxAge: data[4],
        startDate: data[5],
        endDate: data[6],
        pintent_id:pintent_id
      }).then((res) => {
        setLoadingModal(false);
        setIsOpen(false);
        getProgramsPlayer();
      });
    }

    const getCard = async () => {
      setLoadingModal(true);
      var body = {
        "stripe_pm": props.userHome.userData.stripe_pm,
      };
      axios.post(process.env.REACT_APP_BACKEND+'getPMethod', {
        body,header
      })
      .then(function (response) {
        if(response.result==="0"){
          alert(response.message);
          return;
        }
        props.userHome.userData.stripe_pm = response.data.pm_id;
        setStripe_pm(response.data.pm_id);
        setStripe_name(response.data.name);
        setStripe_last4(response.data.last_4);
        setStripe_network(response.data.network);
        setIsStripe_pm(true);
        setLoadingModal(false);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
    }

    const makePayment = async () => {
      setLoadingModal(true);
      // if(player.active_program=="1"){
      //   alert("Player has an active program, please release first...");
      //   return;
      // }
      var body = {
        "uid":uid,
        "program_name":programName,
        "player_id":cookies.get("player"),
        "pintent_id": pintent_id,
        "pmethod_id": stripe_pm,
        "program_id":programId,
      };
      axios.post(process.env.REACT_APP_BACKEND+'confirmPIntents', {
        body,header
      })
      .then(function (response) {
        console.log(response);
        if(response.data.result==="0"){
          setPaymentError(true);
          setPaymentErrorMessage(response.data.message);
          setLoadingModal(false);
          return;
        }
        getProgramsPlayer();
        setSuccessPayment(true);
        setLoadingModal(false);
        setIsOpen2(false);
      })
      .catch(function (error) {
        console.log(error);
      });
    }

    const changeCard = () => {
      setStripe_pm("");
      setStripe_name("");
      setStripe_last4("");
      setStripe_network("");
      setIsStripe_pm(false);
    }

    //PAY PROGRAM
    const addCard = async () => {
      setLoadingModal(true);
      var body = {
        "uid": cookies.get("uid_record"),
        "program_uid": uid,
        "name": cardHolder,
        "number": creditCardNum,
        "exp_month": expireMonth,
        "exp_year": expireYear,
        "cvc": cvv,
        "customer_id": props.userHome.userData.stripe_id,
      };
      axios.post(process.env.REACT_APP_BACKEND+'createPMethod', {
        body,header
      }).then(function (response) {
        console.log(response.data);
        if(response.data.result==="0"){
          setPaymentError(true);
          setPaymentErrorMessage(response.data.message);
          setLoadingModal(false);
          return;
        }
        props.userHome.userData.stripe_pm = response.data.pm_id;
        setStripe_pm(response.data.pm_id);
        setStripe_name(response.data.name);
        setStripe_last4(response.data.last_4);
        setStripe_network(response.data.network);
        
        setIsStripe_pm(true);
        setLoadingModal(false);
      })
      .catch(function (error) {
        console.log(error);
      });
    }

    const uploadFile = async (url) => {
      const userDoc = doc(db, "players", cookies.get("player"));
      var date = new Date();
      const newFields = { 
        profile_picture: url,
        profile_picture_ref: "profilepicture/"+cookies.get("player"),
        modified: date,
        by: props.userHome.userData.name };
      await updateDoc(userDoc, newFields).then((res)=>{
        console.log(res);
        setLoadingModal(false);
        setIsOpen3(false);
      });
    }


    const deleteFile = async () => {
      // alert(name);return;
      setLoading(true);
      const desertRef = ref(storage, "profilepicture/"+cookies.get("player"));
      deleteObject(desertRef).then(async() => {
        const userDoc = doc(db, "players", cookies.get("player"));
        setUrl("")
        var date = new Date();
        const newFields = { 
          profile_picture: "",
          profile_picture_ref: "",
          modified: date,
          by: props.userHome.userData.name };
        await updateDoc(userDoc, newFields).then((res)=>{
          console.log(res);
          closeModal3();
          setLoading(false);
          player.profile_picture = "";
          setUrl("");
        });
      }).catch((error) => {
        console.log(error);
      });
    }

    const deletePlayerFile = async (uid) => {
      // alert(name);return;
      uid = uid.split("***!!!");
      setLoading(true);
      const desertRef = ref(storage, uid[0]);
      deleteObject(desertRef).then(async() => {
        const userDoc = doc(db, "players/"+cookies.get('player')+"/playerfiles", uid[1]);
        await deleteDoc(userDoc).then(()=>{
          closeModal3();
          getFiles();
          setLoading(false);
        });
      }).catch((error) => {
        console.log(error);
      });
    }

    const handleUpload2 = () => {
      setLoadingModal(true);
      const imageRef = ref(storage, "playerfiles/"+cookies.get("player")+"/"+image.name);
      uploadBytes(imageRef, image)
      .then(() => {
        getDownloadURL(imageRef)
          .then((url) => {
            setUrl(url);
            addFile(url);
            console.log(url);
          })
          .catch((error) => {
            console.log(error.message, "error getting the image url");
          });
        setImage(null);
      })
      .catch((error) => {
        console.log(error.message);
      });
    }

    const handleUpload = () => {
      setLoadingModal(true);
      const imageRef = ref(storage, "profilepicture/"+cookies.get("player"));
      uploadBytes(imageRef, image)
      .then(() => {
        getDownloadURL(imageRef)
          .then((url) => {
            setUrl(url);
            uploadFile(url);
          })
          .catch((error) => {
            console.log(error.message, "error getting the image url");
          });
        setImage(null);
      })
      .catch((error) => {
        console.log(error.message);
      });
    };
  
    console.log("image: ", image);
  

    return (

        <div id="list_of_players">
        <h2>Player Information</h2>

        <div className='row' id="data">
        { cookies.get('player') ?
            <>
            <div className='row'>
              <div className='col-lg-12' style={{ display: "flex" }}>
              <button className='btn btn-primary btn-sm' style={{ marginLeft: "0px" }} onClick={()=>{props.updateStatePlayer(2,player.name,player)}}>Modify Player</button>
              <button className='btn btn-danger btn-sm' style={{ marginLeft: "0px" }} onClick={()=>{handleDelete("player",cookies.get("player"),player.name,"")}}>Delete Player</button><br></br>
              </div>
            </div>
            <div className='row'>
              <div className='col-lg-10'>
                <Card>
                  <Card.Body>
                      <Card.Title className='bg-info'>Basic Information</Card.Title>
                      <div className='row'>
                        <div className='col-lg-12'>
                          <div className='row'>
                            <div className='col-lg-3'>
                              Player's Names: <b>{player.name}</b>
                            </div>
                            <div className='col-lg-2'>
                              birthdate: <b>{ Moment(player.birthdate?.toDate()).format('MM/DD/YYYY')}</b>
                            </div>
                            <div className='col-lg-2'>
                              age: <b>{age}</b>
                            </div>
                            <div className='col-lg-2'>
                              Gender: <b>{player.gender}</b>
                            </div>
                            <div className='col-lg-3'>
                              Email Address: <b>{player.email}</b>
                            </div>
                            <div className='row'>
                            <div className='col-lg-3'>
                                Address: <b>{player.address}</b>
                              </div>
                              <div className='col-lg-3'>
                                city: <b>{player.city}</b>
                              </div>
                              <div className='col-lg-3'>
                                state: <b>{player.state}</b>
                              </div>
                              <div className='col-lg-3'>
                                ZIP: <b>{player.zip}</b>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> 
                  </Card.Body>
                </Card>
              </div>
              <div className='col-lg-2'>
                <Card>
                  <Card.Body>
                      <Card.Title className='bg-info'>Profile Picture</Card.Title>
                      <div className='row'>
                              <div className='col-lg-12'>
                              {player.profile_picture || url?<>
                                <br />
                                  <img src={url || player.profile_picture} alt="firebase-image" width={150} height={150} />
                                  {props.userHome.userData.main_user==="1"?<>
                                    <br></br>
                                    <button className='btn btn-sm btn-danger' onClick={()=>{handleDelete("profile_picture",cookies.get("player"),"Profile Picture for "+player.name,"")}}>Delete</button>
                                    <button className='btn btn-sm btn-primary' onClick={openModal3}>Update</button>
                                  </>:""}
                                </>:<>
                                    {props.userHome.userData.main_user==="1"?<>
                                    <br></br>
                                    <button className='btn btn-sm btn-primary' onClick={openModal3}>Upload</button>
                                  </>:""}
                                </>}
                              </div>
                      </div>
                  </Card.Body>
                </Card>
              </div>
              <div className='col-lg-6'>
                <Card>
                  <Card.Body>
                      <Card.Title className='bg-info'>Parent</Card.Title>
                      <div className='row'>
                        <div className='col-lg-6'>
                          Parent Name: <b>{player.parentName1}</b>
                        </div>
                        <div className='col-lg-6'>
                          Home Phone Number: <b>{player.homePhone1}</b>
                        </div>
                        <div className='col-lg-6'>
                          Bussines Phone Number: <b>{player.busPhone1}</b>
                        </div>
                        <div className='col-lg-6'>
                          Email: <b>{player.parentEmail1}</b>
                        </div>
                        <div className='col-lg-6'>
                          Cellphone: <b>{player.parentCellphone1}</b>
                        </div>
                        <div className='col-lg-6'>
                          Text: <b>{player.parentText1=="1"?"Yes":"No"}</b>
                        </div>
                      </div>

                {player.parentName2!=""?
                      <>
                      <Card.Title className='bg-info'>Parent</Card.Title>
                      <div className='row'>
                      <div className='col-lg-6'>
                          Parent Name: <b>{player.parentName2}</b>
                        </div>
                        <div className='col-lg-6'>
                          Home Phone Number: <b>{player.homePhone2}</b>
                        </div>
                        <div className='col-lg-6'>
                          Bussines Phone Number: <b>{player.busPhone2}</b>
                        </div>
                        <div className='col-lg-6'>
                          Email: <b>{player.parentEmail2}</b>
                        </div>
                        <div className='col-lg-6'>
                          Cellphone: <b>{player.parentCellphone2}</b>
                        </div>
                        <div className='col-lg-6'>
                          Text: <b>{player.parentText2=="1"?"Yes":"No"}</b>
                        </div>
                      </div>
                      </>
                :""}
                      <Card.Title className='bg-info'>Emergency Contact</Card.Title>
                      <div className='row'>
                        <div className='col-lg-6'>
                          Name: <b>{player.emergencyName1}</b>
                        </div>
                        <div className='col-lg-6'>
                          Phone1: <b>{player.emergencyPhone1_1}</b>
                        </div>
                        <div className='col-lg-6'>
                          Phone2: <b>{player.emergencyPhone1_2}</b>
                        </div>
                      </div>
                      {player.emergencyName2!=""?
                        <div className='row'>
                          <div className='col-lg-6'>
                            Name: <b>{player.emergencyName2}</b>
                          </div>
                          <div className='col-lg-6'>
                            Phone2: <b>{player.emergencyPhone2_1}</b>
                          </div>
                          <div className='col-lg-6'>
                            Phone2: <b>{player.emergencyPhone2_2}</b>
                          </div>
                        </div>
                      :""}
                  </Card.Body>
                </Card>
              </div>
              <div className='col-lg-6'>
              <Card>
                  <Card.Body>
                      <Card.Title className='bg-info'>Player Medical Information </Card.Title>
                      <div className='row'>
                      <div className='col-lg-12'>
                          Player Allergies: <b>{player.playerAllergies}</b>
                        </div>
                        <div className='col-lg-12'>
                          Player Medical Conditions: <b>{player.playerMedConditions}</b>
                        </div>
                        <div className='col-lg-12'>
                          Physician: <b>{player.physician}</b>
                        </div>
                        <div className='col-lg-6'>
                          Physician Phone 1: <b>{player.physicianPhone}</b>
                        </div>
                        <div className='col-lg-6'>
                          Physician Phone 2: <b>{player.physicianPhone2}</b>
                        </div>
                      </div>
                      <Card.Title className='bg-info'>Insurance </Card.Title>
                      <div className='row'>
                        <div className='col-lg-6'>
                          Company: <b>{player.insuranceCompany}</b>
                        </div>
                        <div className='col-lg-6'>
                          Phone: <b>{player.insuranceCompanyPhone}</b>
                        </div>
                        <div className='col-lg-6'>
                          Policy Holder's Name: <b>{player.policyHoldersName}</b>
                        </div>
                        <div className='col-lg-6'>
                          Policy Number: <b>{player.policyNumber}</b>
                        </div>
                      </div>
                  </Card.Body>
                </Card>
              </div>
              
            </div>
            <div className='row'>
              <div className='col-lg-12' style={{ display: "flex" }}>
              <button className='btn btn-success btn-sm' disabled={disabledEnvelop} style={{ marginLeft: "0px" }}  onClick={openModal}>Add Program</button>
              </div>
            </div>
            <div className='row' style={{overflowX: "scroll"}}>
              <div className='col-lg-12'>
              {errorPayment && (
              <Alert key={"danger"} variant={"danger"}>
                PAYMENT ERROR, PLEASE TRY AGAIN.
              </Alert>
              )}
              {successPayment && (
              <Alert key={"success"} variant={"success"}>
                PAYMENT COMPLETED, THANK YOU!!!
              </Alert>
              )}
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Inscription Date</th>
                    <th>Program Name</th>
                    <th>Price (US Dollars)</th>
                    <th>Min Age</th>
                    <th>Max Age</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Date Paid</th>
                    <th>Payment</th>
                    <th>Doc Status</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                {assignedPrograms.map((assignedProgram) => {
                  rowCounter2++;
                  var date_paid = "";
                  if(assignedProgram.date_paid){
                    date_paid = Moment(assignedProgram.date_paid.toDate()).format('MM/DD/YYYY');
                  }
                  var envelopeButton = "";
                  // alert(assignedProgram.envelopId);
                  if(assignedProgram.envelopeId === undefined){
                    envelopeButton = <>
                      <button className='btn btn-primary btn-sm' disabled={disabledEnvelop} onClick={()=>{sendEnvelope(assignedProgram.id)}}>Sign Documents</button>
                    </>;
                  }else{
                    envelopeButton = <>
                      <button className='btn btn-primary btn-sm' onClick={()=>{getEnvelope(assignedProgram.envelopeId,assignedProgram.id)}}>Review Documents</button>
                    </>;
                  }
                  var deleteButton = "";
                  if(assignedProgram.envelopeCompleted===undefined){
                    deleteButton = <button className='btn btn-danger btn-sm' style={{ marginLeft: "0px" }} 
                    onClick={()=>{handleDelete("program",assignedProgram.id,assignedProgram.program_name,assignedProgram.pintent_id)}}>Delete</button>
                  }
                  
                  return(
                    <tr key={assignedProgram.id}>
                      <td>{rowCounter2}</td>
                      <td>{Moment(assignedProgram.date.toDate()).format('MM/DD/YYYY')}</td>
                      <td>{assignedProgram.program_name}</td>
                      <td>{assignedProgram.price}</td>
                      <td>{assignedProgram.minAge}</td>
                      <td>{assignedProgram.maxAge}</td>
                      <td>{assignedProgram.startDate}</td>
                      <td>{assignedProgram.endDate}</td>
                      <td>{date_paid}</td>
                      <td>{assignedProgram.manual_paid==="yes"?<>
                              <b>{assignedProgram.status}</b><br></br>
                              Manual Paid By: <b>{assignedProgram.manual_paid_by}</b><br></br>
                              Note: <b>{assignedProgram.manual_paid_note}</b>
                          </>:assignedProgram.status}
                      </td>
                      <td>{assignedProgram.envelopeCompleted}</td>
                      <td>
                        
                        {assignedProgram.status != "Paid" && assignedProgram.envelopeId != undefined && assignedProgram.envelopeCompleted != undefined && (
                          <>
                            <button className='btn btn-success btn-sm' onClick={()=>{openModal2(assignedProgram.id,assignedProgram.program_name,assignedProgram.pintent_id,assignedProgram.endDate,assignedProgram.program_id)}}>Pay</button>
                          </>
                        )}  
                        {envelopeButton}
                        {deleteButton}
                      </td>
                    </tr>
                  );
                })}
                </tbody>
              </Table>
              </div>
            </div>
            <div className='row'>
              <div className='col-lg-12' style={{ display: "flex" }}>
                <button className='btn btn-success btn-sm' style={{ marginLeft: "0px" }}  onClick={openModal4}>Add File</button>
              </div>
            </div>
            <div className='row'>
              <div className='col-lg-12' style={{ display: "flex" }}>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>by</th>
                    <th>date</th>
                    <th>File</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                {playerfiles.map((playerfile) => {
                  rowCounter3++;
                  return(
                    <tr key={playerfile.id}>
                      <td>{rowCounter3}</td>
                      <td>{playerfile.by}</td>
                      <td>{Moment(playerfile.date.toDate()).format('MM/DD/YYYY')}</td>
                      <td><button className='btn btn-sm btn-primary'><a href={playerfile.url} target="_BLANK"><font color="#FFFFFF">Download</font></a></button></td>
                      <td><button className='btn btn-sm btn-danger' onClick={()=>{handleDelete("playerfile",playerfile.fileref+"***!!!"+playerfile.id,"File for "+player.name,"")}}>Delete</button></td>
                    </tr>
                  );
                })}
                </tbody>
              </Table>
              </div>
            </div>
            <Modal
              isOpen={modalIsOpen}
              onRequestClose={closeModal}
              style={modalStyle}
              contentLabel="Example Modal"
              closeTimeoutMS={500}>

              {/* {player.active_program!=1?<> */}
                <font ref={(_subtitle) => (subtitle = _subtitle)} style={{size:"25px"}}>Add New Program to <b>{player.name}</b></font>
                <select id="program" className='form-control'>
                {programs.map((program) => {
                  console.log(program);
                  rowCounter++;
                  var option = "";
                  var startDate = Moment(program.startDate.toDate()).format('MM/DD/YYYY');
                  var endDate = Moment(program.endDate.toDate()).format('MM/DD/YYYY');
                  if(program.minAge <= age && program.maxAge >= age){
                    option = <option key={program.id} value={program.id+"****"+program.programName+"****"+program.price+"****"+program.minAge+"****"+program.maxAge+"****"+startDate+"****"+endDate+"****"+program.product_id+"****"+program.price_id}>{program.programName} - minAge: {program.minAge}, maxAge: {program.maxAge}</option>
                  }
                  return(
                    option
                  );
                })}
                </select>
                <br></br>
                <button className='btn btn-danger btn-sm' onClick={closeModal}>Cancel</button>
                <button className='btn btn-success btn-sm' disabled={isLoadingModal} onClick={addProgramSt}>Add</button>
              {/* </>:<>
                Player has an active program.
              </>} */}
              
              {isLoadingModal?<div><img src={Wait} alt="Ball" width="25px" />Processing, please wait...</div>:""}
              {error && (
                <Alert key={"danger"} variant={"danger"}>
                  {errorMessage}
                </Alert>
              )}
            </Modal>
            <Modal
              isOpen={modalIsOpen2}
              onRequestClose={closeModal2}
              style={modalStyle}
              contentLabel="Example Modal"
              closeTimeoutMS={500}> 
              {isStripe_pm === false  ?
              <div className='row'>
                <div className='col-lg-6'>
                  <div id="card">
                      <div className="header">
                          <div className="sticker"></div>
                          <div>
                            <img className="logo" src={cardTypeUrl} alt="Card logo"/>
                          </div>
                      </div>
                      <div className="body">
                          <h2 id="creditCardNumber">{creditCardNum}</h2>
                      </div>
                      <div className="footer">
                          <div>
                              <h5>Card Holder</h5>
                              <h3>{cardHolder}</h3>
                          </div>
                          <div>
                              <h5>Expires</h5>
                              <h3>{expireMonth} / {expireYear}</h3>
                          </div>
                      </div>
                  </div>
                </div>
                <div className='col-lg-6'>
                  <div className='row'>
                    <div className='col-lg-12'>
                      <label>Enter card number</label>
                      <Cleave
                        delimiter="-"
                        className='form-control'
                        options={{
                          creditCard: true,
                          onCreditCardTypeChanged: handleType
                        }}
                        onChange={handleNum}
                        placeholder="Please enter your credit card number"
                      />
                      <label>Card Holder</label>
                      <input className='form-control' onChange={handleCardHolder} type="text" placeholder="Please enter your full name" required/>
                    </div>
                    <div className='col-lg-4'>
                      <label>Exp Year</label>
                      <select className='form-control' value={expireMonth} onChange={handleExpMonth}>
                        <option value="01" selected>January</option>
                        <option value="02">February</option>
                        <option value="03">March</option>
                        <option value="04">April</option>
                        <option value="05">May</option>
                        <option value="06">June</option>
                        <option value="07">July</option>
                        <option value="08">August</option>
                        <option value="09">September</option>
                        <option value="10">October</option>
                        <option value="11">November</option>
                        <option value="12">December</option>
                      </select>
                    </div>
                    <div className='col-lg-4'>
                      <label>Month</label>
                      <select className='form-control' value={expireYear} onChange={handleExpYear}>
                        <option value="2021" selected>2021</option>
                        <option value="2022">2022</option>
                        <option value="2023">2023</option>
                        <option value="2024">2024</option>
                        <option value="2025">2025</option>
                        <option value="2026">2026</option>
                        <option value="2027">2027</option>
                        <option value="2028">2028</option>
                        <option value="2029">2029</option>
                      </select>
                    </div>
                    <div className='col-lg-4'>
                      <label>CVV</label>
                      <input className='form-control' type="password" placeholder="CVV" onChange={handlecvc} required/>
                    </div>
                    <div className='col-lg-12'>
                      <button className='btn btn-danger btn-sm' onClick={closeModal2}>Cancel</button>
                      <button className='btn btn-success btn-sm' onClick={addCard}
                      disabled={isLoadingModal}>Add card</button>
                    </div>
                  </div>
                </div>
              </div>
              : 
                       <div className='row'>
                        <div className='col-lg-10'>
                          <Alert key={"success"} variant={"success"}>
                            Pay with <b>{stripe_network}</b>, name <b>{stripe_name}</b>, ending in <b>****{stripe_last4}</b>
                          </Alert>
                        </div>
                        <div className='col-lg-2'>
                            <button className='btn btn-success btn-lg' onClick={makePayment}
                              disabled={isLoadingModal}>PAY</button>
                        </div>
                        <div className='col-lg-12'>
                            <button className='btn btn-danger btn-sm' onClick={closeModal2}>Cancel</button>
                            <button className='btn btn-primary btn-sm' onClick={changeCard}>Change card</button>
                        </div>
                       </div> 
              }
              {isLoadingModal?<div><img src={Wait} alt="Ball" width="25px" />Processing, please wait...</div>:""}
              {paymentError && (
                <Alert key={"danger"} variant={"danger"}>
                  {paymentErrorMessage}
                </Alert>
              )}
              {props.userHome.userData.main_user==="1"?<>
                <br></br>
                <label>Write a note to release a payment</label>
                <textarea class="form-control" rows="3" onChange={(event)=>{setReleasePaymentNote(event.target.value)}}></textarea><br></br>
                <button className='btn btn-sm btn-primary' onClick={releasePaymentSt}>Release Payment</button>
              </>:""}
              
            </Modal>
            <Modal
              isOpen={modalIsOpen3}
              onRequestClose={closeModal3}
              style={modalStyle}
              contentLabel="Example Modal"
              closeTimeoutMS={500}>
              <font ref={(_subtitle) => (subtitle = _subtitle)} style={{size:"25px"}}>Add New Picture to <b>{player.name}</b></font>
              <input type="file" onChange={handleChange} className="form-control"/>
              <progress value={progress} max="100" />
              <br></br>
              <button className='btn btn-danger btn-sm' onClick={closeModal3}>Cancel</button>
              <button className='btn btn-success btn-sm' disabled={isLoadingModal} onClick={handleUpload}>Add</button>
              {isLoadingModal?<div><img src={Wait} alt="Ball" width="25px" />Processing, please wait...</div>:""}
            </Modal>
            <Modal
              isOpen={modalIsOpen4}
              onRequestClose={closeModal4}
              style={modalStyle}
              contentLabel="Example Modal"
              closeTimeoutMS={500}>
              <font ref={(_subtitle) => (subtitle = _subtitle)} style={{size:"25px"}}>Add New File to <b>{player.name}</b></font>
              <input type="file" onChange={handleChange} className="form-control"/>
              <progress value={progress} max="100" />
              <br></br>
              <button className='btn btn-danger btn-sm' onClick={closeModal4}>Cancel</button>
              <button className='btn btn-success btn-sm' disabled={isLoadingModal} onClick={handleUpload2}>Add</button>
              {isLoadingModal?<div><img src={Wait} alt="Ball" width="25px" />Processing, please wait...</div>:""}
            </Modal>
            </>
          : "No Player Selected"
         }
         </div>
         <div className="loader-container" id="loader">
              <div className="loader"></div>
          </div>
          {dialog.isLoading && (
              <Dialog
          //Update
          nameProduct={dialog.nameProduct}
          onDialog={areUSureDelete}
          message={dialog.message}
        />
      )}
         </div>
    )   
}

export default PlayerList;